<template>
    <v-card class="pa-3 mt-3" :loading="loading.order">
        <table width="100%" v-if="!loading.order">
            <tr v-if="isMidiaExterior">
                <th align="right">Período do plano:</th>
                <td>{{ planPeriods }} ({{ planPeriods === 1 ? 'período contratado' : 'períodos contratados' }})</td>
                <th align="right">Quantidade do plano:</th>
                <td>{{ planQuantityLabel }}</td>
            </tr>
            <tr v-else>
                <th align="right">Quantidade do plano:</th>
                <td colspan="3">{{ planQuantityLabel }}</td>
            </tr>
            <tr>
                <th align="right">Valor sem desconto:</th>
                <td colspan="3">{{ $n(item.totalPrice, 'currency') }}</td>
            </tr>
            <tr>
                <th align="right" style="border-top: 1px solid #2196F3; border-bottom: 1px solid #2196F3;">Aplicar desconto:
                </th>
                <td colspan="3" style="border-top: 1px solid #2196F3; border-bottom: 1px solid #2196F3;">
                    <div class="d-flex align-center outlined">
                        <v-text-field :disabled="item.expired === true || !isExecutive || !quotationStatusRange.includes(item.orderStatusId)" class="mt-8" @input="checkPercent()" v-mask="'##.##'" :hint="item.asuFormat.asus.private_pricing_info.discount == value ? 'Este é o desconto inicial cadastrado' : ''" :tokens="customTokens" @blur="checkPercent()"  :min="0" :max="100"
                            v-show="!invert"  color="primary" v-model="value" outlined rounded
                            label="Percentual" append-icon="mdi-percent-outline"></v-text-field>
                        <v-text-field :disabled="item.expired === true || !isExecutive || !quotationStatusRange.includes(item.orderStatusId)" class="mt-8" @input="checkValue()" @blur="checkValue()" v-money="money" v-show="invert"
                             color="primary" v-model="fixedValue" outlined rounded label="Valor"
                            prepend-inner-icon="mdi-currency-brl"></v-text-field>

                        <v-btn icon :disabled="item.expired === true || !isExecutive || !quotationStatusRange.includes(item.orderStatusId)" class="mx-1" @click="invert = !invert">
                            <v-icon icon>mdi-swap-horizontal</v-icon>
                        </v-btn>
                        <v-text-field type="number" disabled hide-details v-show="invert" color="primary"
                            v-model="value" outlined rounded label="Percentual"
                            append-icon="mdi-percent-outline"></v-text-field>
                        <v-text-field v-money="money" disabled hide-details v-show="!invert" color="primary"
                            v-model="fixedValue" outlined rounded label="Valor"
                            prepend-inner-icon="mdi-currency-brl"></v-text-field>
                    </div>
                </td>
            </tr>
            <tr>
                <th align="right">Negociação final:</th>
                <td></td>
                <td></td>
                <td><v-btn :disabled="item.expired === true || !isExecutive || !quotationStatusRange.includes(item.orderStatusId)" @click="attachmentModal.show = true" rounded block small color="primary" elevation="0">Upload de arquivo <v-icon small
                            right>mdi-upload</v-icon></v-btn></td>
            </tr>
            <tr>
                <th align="right">Valor bruto final:</th>
                <td>{{ $n(finalPrice, 'currency') }}</td>
                <td></td>
                <td>
                    <v-btn :disabled="item.expired === true || !isExecutive || !quotationStatusRange.includes(item.orderStatusId)" @click="accept.show = true" rounded block small color="success" elevation="0">Salvar e enviar <v-icon small
                            right>mdi-send-variant</v-icon></v-btn>
                </td>
            </tr>
          
            <tr>
                <th align="right">Valor líquido final</th>
                <td>
                    {{ $n(finalPrice * 0.8, 'currency') }} (80% do bruto)
                </td>
                <td></td>
                <td>

                    <v-btn :disabled="item.expired === true || !isExecutive || !quotationStatusRange.includes(item.orderStatusId)" @click="cancel.confirm = false; cancel.show = true" rounded block outlined color="error" small>Reprovar cotação <v-icon small
                            right>mdi-cancel</v-icon></v-btn>
                </td>

            </tr>

              <tr v-if="filteredSsuOrders.length">
                <th align="right">Serviço complementar:</th>
          
                <td>
                    {{ $n(ssuTotalPrice * 0.8, 'currency') }}
                    <v-icon
                        small
                        class="mx-1"
                        color="white"
                        style="background-color: #0e1439; border-radius: 50%; padding: 4px; cursor: pointer;"
                        @click="showSsuDetails = !showSsuDetails"
                    >
                        {{ showSsuDetails ? 'mdi-minus' : 'mdi-plus' }}
                    </v-icon>
                    <strong>Valor final total (líquido)</strong> {{ $n((finalPrice * 0.8) + (ssuTotalPrice * 0.8), 'currency') }}
                </td>
            </tr>

        </table>

        <quotation-ssu-order 
            v-if="showSsuDetails && filteredSsuOrders.length"
            :ssu-orders="filteredSsuOrders"
            :is-executive="isExecutive"
            :expired="item.expired"
            @refresh="$emit('response-quotation')"
        />

        <v-dialog max-width="768" v-model="cancel.show" @click:outside="cancel.confirm = false">
            <v-card v-if="cancel.show">
                <template v-if="!cancel.confirm">
                    <v-card-title>Reprovar cotação</v-card-title>
                    <v-card-text>
                        <v-alert type="warning" dense text class="mb-3">
                            A negociação será encerrada.
                        </v-alert>
                        <p class="font-weight-medium mb-1">Ao reprovar esta cotação:</p>
                        <ul class="mb-4" style="padding-left: 1.2em;">
                            <li>O formato será removido do plano do cliente.</li>
                            <li>O cliente poderá inserir novamente o formato posteriormente.</li>
                            <li>Caso o problema seja preço ou informação incorreta, recomendamos solicitar correção ao invés de reprovar.</li>
                        </ul>
                        <p class="mb-1">Por favor, descreva em poucas palavras o motivo da recusa.</p>
                        <v-textarea v-model="cancel.reason" label="Motivo" outlined></v-textarea>

                        <div class="d-flex">
                            <v-spacer></v-spacer>
                            <v-btn text @click="cancel.show = false; cancel.confirm = false">Cancelar</v-btn>
                            <v-btn color="error" :disabled="!cancel.reason || cancel.reason.trim() === ''" @click="cancel.confirm = true">Reprovar cotação</v-btn>
                        </div>
                    </v-card-text>
                </template>

                <template v-else>
                    <v-card-title>Tem certeza?</v-card-title>
                    <v-card-text>
                        <p class="body-1 mb-4">
                            Esta ação encerrará a negociação<br>e removerá o item do plano.
                        </p>
                        <div class="d-flex">
                            <v-spacer></v-spacer>
                            <v-btn text @click="cancel.confirm = false">Voltar</v-btn>
                            <v-btn color="error" @click="saveOrder('reject')" :loading="cancel.loading">Confirmar reprovação</v-btn>
                        </div>
                    </v-card-text>
                </template>
            </v-card>
        </v-dialog>
         <v-dialog max-width="640" v-model="accept.show">
            <v-card v-if="accept.show">
                <v-card-title class="d-flex justify-space-between align-start" style="flex-wrap: nowrap; gap: 16px;">
                    Confirme a negociação para prosseguir:
                    <span v-if="item.users && item.users.find(u => u.isExecutiveFromGrid)" class="text-right body-2 grey--text text--darken-1" style="line-height: 1.5; font-weight: normal; margin-top: 6px;">
                        Executivo responsável<br>
                        <strong class="grey--text text--darken-3">{{ item.users.find(u => u.isExecutiveFromGrid).name }}</strong><br>
                        {{ item.users.find(u => u.isExecutiveFromGrid).email }}
                    </span>
                </v-card-title>
                <v-card-text>
                    <h4 class="blue--text mt-0 mb-2">Cliente {{ item.pro_displayname }} - {{ item.pro_document | document }}</h4>
                    <ul>
                        <li><strong>Inventário: </strong> {{ item.asuFormat.display_name }}</li>
                        <li><strong>Formato: </strong> {{ item.asuFormat.asus.format | asuFormat }}</li>
                        <li v-if="item.asuFormat.asus.asu_client_id"><strong>Código: </strong> {{ item.asuFormat.asus.asu_client_id }}</li>
                        <li><strong>Detalhes: </strong> {{ item.asuFormat.asus.bucket | asuBuckets }}</li>
                        <li><strong>Localização: </strong> <span v-if="item.asuFormat.asus.locations.length">{{ item.asuFormat.asus.locations[0] | location }}</span><span class="ml-2" v-if="item.asuFormat.asus.locations.length - 1 > 0">+{{ item.asuFormat.asus.locations.length - 1 }} localidade</span></li>
                    </ul>
                    <v-divider class="my-3"></v-divider>
                    <div class="d-flex align-end justify-space-between">
                        <ul style="flex: 1;">
                            <li><strong>Período de veiculação: </strong> {{ item.startAtDate | date }} {{ item.endAtDate | date }}</li>
                            <li><strong>Quantidade no pedido: </strong> {{ $n(planQuantity) }} {{ planQuantity > 1 ? 'inserções' : 'inserção' }} distribuídas em {{ $n(planPeriods) }} {{ planPeriods > 1 ? 'períodos' : 'período' }}</li>
                            <li><strong>Valor tabela bruto unit.: </strong> {{ $n(unitTablePrice, 'currency') }}</li>
                            <li><strong>Valor tabela bruto total: </strong> {{ $n(item.totalPrice, 'currency') }}</li>
                            <li><strong>Desconto:</strong> {{$n(value)}}%</li>
                            <li style="font-size: 1.2em"><strong>Valor bruto final:</strong> {{ $n(finalPrice, 'currency') }}</li>
                            <li style="font-size: 1.2em; color: #000; font-weight: bold"><strong>Valor líquido final:</strong> {{ $n(finalPrice * 0.8, 'currency') }} (80%)</li>
                            <li v-if="filteredSsuOrders.filter(ssu => ssu.status !== 13).length" class="d-flex align-center" style="margin-top: 8px;">
                                <v-icon small color="primary" class="mr-1">mdi-plus-circle</v-icon>
                                <strong>Serviço complementar</strong>
                                <span class="ml-2">{{ $n(ssuTotalPrice * 0.8, 'currency') }}</span>
                            </li>
                            <li v-if="filteredSsuOrders.filter(ssu => ssu.status !== 13).length" style="font-size: 1.2em; margin-top: 8px; padding-top: 8px; border-top: 1px solid #e0e0e0;">
                                <strong>Valor líquido total</strong> {{ $n((finalPrice * 0.8) + (ssuTotalPrice * 0.8), 'currency') }}
                            </li>
                        </ul>
                        <div style="flex: 0 0 280px; margin-left: 5px;">
                            <v-textarea
                                v-model="accept.observation"
                                outlined
                                dense
                                rows="3"
                                hide-details
                                placeholder="Observação (opcional)"
                                class="mb-3"
                            ></v-textarea>
                            <v-btn block color="success" elevation="0" class="mb-1 mx-0" x-large @click="saveOrder('accepted')" :loading="accept.loading">Aplicar condição</v-btn>
                            <v-btn block outlined color="error" small @click="accept.show = false" class="mx-0">Cancelar</v-btn>
                        </div>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-snackbar v-model="snackbar.show">
            {{ snackbar.text }}

            <template v-slot:action="{ attrs }">
                <v-btn
                icon
                v-bind="attrs"
                @click="snackbar.show = false"
                >
                <v-icon>mdi-close</v-icon>
                </v-btn>
            </template>
            </v-snackbar>

        <attachment-upload-modal
            v-model="attachmentModal.show"
            :item="item"
            @attachment-uploaded="handleAttachmentUploaded"
            @error="handleAttachmentError"
        />
    </v-card>
</template>
<script>
import snackbar from '@/store/snackbar';
import moment from 'moment'
import QuotationSsuOrder from './QuotationSsuOrder.vue'
import AttachmentUploadModal from './AttachmentUploadModal.vue'

export default {
    components: {
        QuotationSsuOrder,
        AttachmentUploadModal
    },
    data() {
        return {
            showSsuDetails: false,
            loading: {
                accept: false,
                reject: false,
                order: true,
                loading: false
            },
            snackbar: {
                show: false,
                text: ''
            },
            cancel: {
                show: false,
                confirm: false,
                reason: "",
                text: "",
                loading: false,
            },
            accept: {
                show: false,
                loading: false,
                observation: ''
            },
            attachmentModal: {
                show: false
            },
            quotation: {},
            type: 'percent',
            value: '',
            fixedValue: '',
            finalPrice: '',
            invert: false,
            customTokens: {
                '#': { pattern: /\d/, optional: true },
                '0': { pattern: /\d/ },
            },
            money: {
                decimal: ",",
                thousands: ".",
                prefix: "",
                suffix: "",
                precision: 2,
                unmaskedVar: "rawPrice"
            },
            number: {
                decimal: ",",
                thousands: ".",
                prefix: "",
                suffix: "",
                precision: 2,
                unmaskedVar: "rawPrice"
            }
        }
    },
    props: {
        item: Object,
        computedTotals: Object,
        quotationStatusRange: Array,
        isExecutive: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        'cancel.show'(v) {
            if (!v) this.cancel.confirm = false
        },
        value(v) {
            if (!this.invert) {
                const percentValue = parseFloat(String(v).replace(',', '.')) || 0
                
                const discountAmount = this.item.totalPrice * (percentValue / 100)
                
                this.fixedValue = discountAmount.toFixed(2).replace('.', ',')
                
                this.finalPrice = Math.round((this.item.totalPrice - discountAmount) * 100) / 100
            }
        },
        fixedValue(v) {
            if (this.invert) {
                const discountAmount = parseFloat(
                    String(v).replace(/\./g, '').replace(',', '.')
                ) || 0
                
                if (this.item.totalPrice > 0) {
                    const percentValue = (discountAmount / this.item.totalPrice) * 100
                    this.value = Math.round(percentValue * 100) / 100
                } else {
                    this.value = 0
                }
                
                this.finalPrice = Math.round((this.item.totalPrice - discountAmount) * 100) / 100
            }
        }
    },
    mounted() {
        this.currentQuotation()
    },
    computed: {
        isMidiaExterior() {
            return this.item.asuFormat?.asus?.media_type?.[0]?.parents?.[0] === 'Mídia Exterior'
        },
        formulaBase() {
            return this.item.asuFormat?.asus?.formula?.base || ''
        },
        formulaHasQ() {
            return this.formulaBase.includes('Q')
        },
        formulaHasI() {
            return this.formulaBase.includes('I')
        },
        isInsertionFormat() {
            return this.formulaHasI
        },
        planPeriods() {
            if (this.isInsertionFormat && !this.formulaHasQ) return 1
            if (Array.isArray(this.item.periods) && this.item.periods.length) return this.item.periods.length
            return Number(this.item.fractionalQuantity) || 0
        },
        planQuantityQ() {
            if (this.item.syncQuantity != null) return this.item.syncQuantity
            const periods = this.item.periods
            if (Array.isArray(periods) && periods.length) {
                return periods.reduce((sum, p) => sum + (Number(p.quantity) || 0), 0)
            }
            return Number(this.item.fractionalQuantity) || 0
        },
        planQuantityI() {
            if (this.item.syncInsertions != null) return this.item.syncInsertions
            const periods = this.item.periods
            if (Array.isArray(periods) && periods.length) {
                return periods.reduce((sum, p) => sum + (Number(p.insertions) || 0), 0)
            }
            return Number(this.item.insertions) || 0
        },
        planQuantity() {
            if (this.formulaHasQ) return this.planQuantityQ
            return this.planQuantityI
        },
        planQuantityLabel() {
            const cm = this.item.asuFormat?.asus?.custom_messages || {}
            if (this.formulaHasQ && this.formulaHasI) {
                const qLabel = cm.msg_quantity || ''
                const iVal = this.planQuantityI
                const iLabel = cm.msg_insertions || (iVal === 1 ? 'inserção' : 'inserções')
                const qPart = [this.planQuantityQ, qLabel].filter(Boolean).join(' ')
                const iPart = `${iVal} ${iLabel}`
                return `${qPart} | ${iPart}`
            }
            if (this.formulaHasQ) {
                const qLabel = cm.msg_quantity || ''
                const periods = this.item.periods || []
                const quantities = periods.map(p => Number(p.quantity) || 0)

                if (quantities.length > 0) {
                    const allSame = quantities.every(q => q === quantities[0])
                    if (allSame) {
                        const perPeriod = quantities[0]
                        const matchesTotal = Math.abs((this.unitTablePrice * perPeriod) - this.item.totalPrice) < 0.01
                        const value = matchesTotal ? perPeriod : this.planQuantityQ
                        return [value, qLabel].filter(Boolean).join(' ')
                    } else {
                        // Quantidades diferentes → mostra total distribuído pelos períodos
                        const total = this.planQuantityQ
                        const numPeriods = this.planPeriods
                        const valuePart = [total, qLabel].filter(Boolean).join(' ')
                        return `${valuePart} distribuídos por ${numPeriods} ${numPeriods === 1 ? 'período' : 'períodos'}`
                    }
                }
                return [this.planQuantityQ, qLabel].filter(Boolean).join(' ')
            }
            const iVal = this.planQuantityI
            const iLabel = cm.msg_insertions || (iVal === 1 ? 'inserção' : 'inserções')
            return `${iVal} ${iLabel}`
        },
        filteredSsuOrders() {
            if (!this.item.ssuOrders || !this.item.ssuOrders.length) return []
            
            return this.item.ssuOrders.filter(ssu => {
                return ssu.providerData && 
                       ssu.providerData.profileId && 
                       String(ssu.providerData.profileId) !== String(this.item.pro_id)
            })
        },
        ssuTotalPrice() {
            if (!this.filteredSsuOrders.length) return 0
            return this.filteredSsuOrders
                .filter(ssu => ssu.status !== 13)
                .reduce((total, ssu) => total + (ssu.totalPrice || 0), 0)
        },
        unitTablePrice() {
            const total = parseFloat(this.item.totalPrice) || 0
            const divisor = this.isInsertionFormat
                ? (this.planQuantity || 1)
                : (Number(this.item.fractionalQuantity) || 1)
            return total / divisor
        }
    },
    methods: {
        checkPercent() {
            let value = this.value
            if (value > 100) this.value = 100
            if (value < 0) this.value = 0
        },
        checkValue() {
            let value = (this.fixedValue.split('.').join('').split(',').join('') / 100)
            if (value > this.item.totalPrice)
                this.fixedValue = this.item.totalPrice
            if (value < 0) this.fixedValue = 0
        },
        currentQuotation() {
            this.loading.order = true
            let k = 0 //item.lastQuotation?.flow.length - 1
            const res = {}
            const item = this.item
            const flow = item.lastQuotation && item.lastQuotation.flow.length ? item.lastQuotation.flow[k] : { action: "", user: null, createdOn: null }
            if (flow.user && flow.user.name && !['created', 'add_quotation'].includes(item.lastQuotation.flow[k].action))
                res.userName = flow.user.name
            if (flow.user && flow.user.email && !['created', 'add_quotation'].includes(item.lastQuotation.flow[k].action))
                res.userEmail = flow.user.email
            if (flow.createdOn && !['created', 'add_quotation'].includes(item.lastQuotation.flow[k].action))
                res.createdOn = moment(flow.createdOn).format('DD/MM/YYYY HH:mm')
            if (flow.action)
                res.action = flow.action

            if (flow.values && Object.keys(flow.values).length && !['created', 'add_quotation'].includes(item.lastQuotation.flow[k].action)) {
                res.quotationString = `${flow.values.value} ${flow.values.type == 'percent' ? '%' : ''}`
                this.type = flow.values.type
                this.value = flow.values.value
            }
            else{
                this.type = 'percent'
                const totalPrice = parseFloat(item.totalPrice) || 0
                const finalPrice = parseFloat(item.finalPrice) || 0
                if (totalPrice > 0 && finalPrice > 0 && finalPrice < totalPrice) {
                    this.value = Math.round((1 - finalPrice / totalPrice) * 10000) / 100
                } else {
                    this.value = item.asuFormat.asus.private_pricing_info.discount
                }
            }
            this.quotation = res
            this.loading.order = false
        },
        buildNegotiationSummary(){
            const f = this.$options.filters
            const asus = (this.item.asuFormat && this.item.asuFormat.asus) ? this.item.asuFormat.asus : {}

            let location = ''
            const locs = asus.locations || []
            if (locs.length) {
                const first = f.location(locs[0])
                location = Array.isArray(first) ? first.join(' - ') : String(first || '')
                const extra = locs.length - 1
                if (extra > 0) location += ` +${extra} ${extra > 1 ? 'localidades' : 'localidade'}`
            }

            const toCurrency = (v) => {
                const n = Number(v)
                if (v === '' || v === null || typeof v === 'undefined' || isNaN(n)) return ''
                return n.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
            }
            const hasFinal = this.finalPrice !== '' && !isNaN(Number(this.finalPrice))

            const hasDiscount = !(this.value === '' || this.value === null || typeof this.value === 'undefined')

            return {
                format:        asus.format ? f.asuFormat(asus.format) : '',
                details:       asus.bucket ? f.asuBuckets(asus.bucket) : '',
                location,
                startDate:     this.item.startAtDate ? f.date(this.item.startAtDate) : '',
                endDate:       this.item.endAtDate ? f.date(this.item.endAtDate) : '',
                quantity:      this.planQuantity || '',
                grossValue:    toCurrency(this.unitTablePrice),
                discount:      hasDiscount ? this.value : '',
                bonusCondition: hasDiscount ? `${this.value}%` : '',
                netValue:      hasFinal ? toCurrency(Number(this.finalPrice) * 0.8) : '',
            }
        },
        saveOrder(action){

            const form = {
               "action": action
            }
            Object.assign(form, this.buildNegotiationSummary())
            if(action == 'reject'){
                this.cancel.loading = true
                form.reason = this.cancel.reason
            }
            else {
                this.accept.loading = true
                form.discount = this.value
                form.notes = this.accept.observation
            }
            
            
            
            
            this.loading[action] = true
            this.$axios.put(`/portal/request/quotation/${this.item.orderSyncId}`, form).then((res) => {
                this.loading[action] = false
                switch(action){
                    case 'reject': 
                    this.snackbar.text = 'Este item foi rejeitado e removido do plano do cliente.'
                    break;
                    case 'accept':
                    this.snackbar.text = 'Você aprovou a proposta do cliente.'
                    break;
                }
                this.$emit('response-quotation', this.item.orderSyncId)
                if(action == 'reject'){
                    this.cancel.loading = false
                    this.cancel.confirm = false
                    this.cancel.show = false
                }
                else {
                    this.accept.loading = false
                    this.$emit('accepted-quotation')
                }

            }, (err) => {
                this.loading[action] = false
                if(action == 'reject'){
                    this.cancel.loading = false
                    this.cancel.confirm = false
                }
                else this.accept.loading = false
                alert('ERRO AO REJEITAR');
            })
        },
        handleConfirmSsu(data) {
            console.log('Confirmar SSU:', data)
            
            this.$emit('confirm-ssu', data)
        },
        handleRejectSsu(data) {
            console.log('Rejeitar SSU:', data)
            
            this.$emit('reject-ssu', data)
        },
        handleAttachmentUploaded(data) {
            this.snackbar.text = 'Arquivo anexado com sucesso!'
            this.snackbar.show = true
            this.$emit('attachment-uploaded', data)
        },
        handleAttachmentError(error) {
            this.snackbar.text = 'Erro ao enviar arquivo. Tente novamente.'
            this.snackbar.show = true
        }
    }
}
</script>